import React from 'react';
import PropTypes from 'prop-types';

import Spacing from '../Spacing';
import HtmlElement from '../HtmlElement';

const defaultProps = {
  htmlFor: '',
};

const propTypes = {
  value: PropTypes.string.isRequired,
  htmlFor: PropTypes.string,
};

const FormLabel = ({
  value,
  htmlFor,
}) => (
  <HtmlElement
    tagName="label"
    htmlFor={htmlFor}
    className="font-medium"
  >
    <Spacing bottom={1}>
      {value}
    </Spacing>
  </HtmlElement>
);

FormLabel.defaultProps = defaultProps;
FormLabel.propTypes = propTypes;

export default FormLabel;
